<div class="modal fade" tabindex="-1" role="dialog" [id]="modalId" [attr.aria-labelledby]="modal.header">
	<div class="modal-dialog" role="document">
		<div class="modal-content">
			<div class="container">
				<div class="row">
					<div class="col-11 p-0 m-0">
						<div class="modal-header p-2">
							<h2 class="modal-title h5" [id]="'layerModalHeader ' + modalId">{{ modal.header }}</h2>
						</div>
					</div>
					<div class="col-1 p-0 m-0">
						<button
							class="modal-close-button p-0 m-0"
							type="button"
							data-bs-dismiss="modal"
							aria-label="Chiudi finestra modale">
							<app-icon innerClass="icon" name="it-close" color="black"></app-icon>
						</button>
					</div>
				</div>
				<div class="row">
					<div class="modal-body p-2">
						<p>{{ modal.body }}</p>
					</div>
				</div>
			</div>
		</div>
	</div>
</div>
